export const CRITICAL_ALERTS_URL = '/v2/flashalerts';
